<template>
  <div id="app">
    <router-view v-if="isRouterAlive"/>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapActions } from 'vuex'
import { resgitserBus } from './api'
import { MessageBox, Message } from 'element-ui'

// const eventBus = new Vue()
export default {
  data () {
    return {
      bus: new Vue(),
      isRouterAlive: true
    }
  },
  created () {
    // this.bus = eventBus
    resgitserBus(this.bus)
    this.bus.$on('accountChanged', () => {
      MessageBox.alert('Organization has been changed, reload the page ?', {
        confirmButtonText: 'Reload',
        callback: () => {
          location.reload()
        }
      })
    })

    this.bus.$on('unlogin', () => {
      Message.error({
        showClose: true,
        duration: 5000,
        dangerouslyUseHTMLString: true,
        message: 'Login info expired, please login again'
      })
      this.logout().then(() => {
        this.$router.replace({ name: 'Login' })
      })
    })

    this.bus.$on('loginFailed', () => {
      Message.error({
        showClose: true,
        duration: 5000,
        dangerouslyUseHTMLString: true,
        message: 'Login failed. Incorrect email or password'
      })
    })

    this.bus.$on('apiTooMany', () => {
      Message.error({
        showClose: true,
        duration: 5000,
        dangerouslyUseHTMLString: true,
        message: 'Too many attempts, please slow down the fresh pace'
      })
    })
    this.bus.$on('processError', messages => {
      Message.error({
        showClose: true,
        duration: 5000,
        dangerouslyUseHTMLString: true,
        message: messages
      })
    })
  },
  methods: {
    ...mapActions({
      logout: 'oauth/logoutAction'
    }),
    reload () {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    }
  },
  provide () {
    return {
      reload: this.reload,
      bus: this.bus
    }
  }
}
</script>

<style lang="scss">
html,
body {
  font-family: Inter,Avenir,Arial,sans-serif,system-ui,Helvetica;
  height: 100%;
  margin: 0;
  padding: 0;
}
#app {
  height: 100%;
  min-width: 1880px;
}
</style>
